import * as React from 'react';
import {Switch, Route, withRouter} from 'react-router-dom';
// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';

import {ExpiredPage} from './expired-page';
import {
    STEP_COMPANY,
    STEP_FEATURES,
    STEP_TEAM,
    STEP_CRM_EXPERIENCE,
    STEP_COMPLETE,
} from './gathering/consts';
import {GatheringPage} from './gathering/gathering-page';
import {JoinYourTeamPage} from './join-your-team/join-your-team-page';
import {LoginRoot} from './login/login-root';
import {OldBrowserPage} from './old-browser-page';
import {PausedPage} from './paused-page';
import {SignupPage} from './signup/signup-page';
import {VerifyEmailPage} from './verify-email/verify-email-page';
import {VerifySenderPage} from './verify-sender/verify-sender-page';

type Props = ContextRouter;

/*
 * This is the top-level ui component for pages which are shown before authentication,
 * including signup, welcome screens, and login
 */

export class AuthRootComponent extends React.Component<Props> {
    componentDidMount(): void {
        // @ts-expect-error
        this.props.history.listen((location) => {
            // @ts-expect-error
            dataLayer.push({
                event: 'clientPageview',
                pageUrl: location.pathname,
            });
        });
    }

    render() {
        return (
            <Switch>
                <Route path='/auth/expired' component={ExpiredPage} />
                <Route path='/auth/paused' component={PausedPage} />
                <Route path='/auth/join-your-team' component={JoinYourTeamPage} />
                <Route path='/auth/old-browser' component={OldBrowserPage} />
                <Route path='/auth' component={LoginRoot} />
                <Route path='/my-account/verify-email' component={VerifyEmailPage} />
                <Route path='/email-verify/success' component={VerifySenderPage} />
                <Route path='/email-verify/failure' component={VerifySenderPage} />
                <Route
                    path='/signup/zendesksell'
                    render={(props) => <SignupPage {...props} signupStartPage={'ZENDESK_SELL'} />}
                />
                <Route
                    path={[
                        `/signup/${STEP_COMPANY}`,
                        `/signup/${STEP_FEATURES}`,
                        `/signup/${STEP_TEAM}`,
                        `/signup/${STEP_CRM_EXPERIENCE}`,
                        `/signup/${STEP_COMPLETE}`,
                    ]}
                    exact={true}
                    render={(routeProps) => {
                        return <GatheringPage {...routeProps} />;
                    }}
                />
                <Route
                    path='/signup'
                    render={(props) => <SignupPage {...props} signupStartPage={null} />}
                />
            </Switch>
        );
    }
}

// @ts-expect-error
export const AuthRoot = withRouter<Record<any, any>>(AuthRootComponent);
